export type Sort<T> = T extends object ? ObjectSort<T> : ValueSort<T>;

export interface ObjectSort<T> {
  property: string;
  direction: 'asc' | 'desc';
  comparator?: (o: any, p: any) => number;
}

export interface ValueSort<T> {
  direction: 'asc' | 'desc';
  comparator?: (o: T, p: T) => number;
}

export function isObjectSort<T>(sort: unknown): sort is ObjectSort<T> {
  return (sort as ObjectSort<T>).property !== undefined;
}
